import { taggedTemplateLiteral as _taggedTemplateLiteral, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from '../../theming/styled-components.js';
import themes from '../../theming/themes.js';
import React, { memo } from 'react';
import withDefaultTheme from '../../hocs/withDefaultTheme.js';
import _Icon from '../Icon/index.js';

var _excluded = ["theme", "error", "children", "hidden", "showIcon", "invertColors"];
var _templateObject;
var StyledSub = styled('sub')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: ", ";\n  align-items: center;\n  text-align: left;\n  font-size: 14px;\n  margin-top: ", ";\n  color: ", ";\n  opacity: ", ";\n  height: ", ";\n  width: ", ";\n\n  & span {\n    margin-left: 0.25rem;\n  }\n\n  & i {\n    font-size: ", ";\n  }\n"])), function (_ref) {
  var error = _ref.error,
    focus = _ref.focus;
  return error || focus ? 'flex' : 'none';
}, function (_ref2) {
  var hidden = _ref2.hidden;
  return !hidden ? '5px' : undefined;
}, function (_ref3) {
  var _ref3$theme = _ref3.theme,
    theme = _ref3$theme === void 0 ? themes["default"] : _ref3$theme,
    error = _ref3.error,
    invertColors = _ref3.invertColors;
  return invertColors ? theme.palette.white : error ? theme.palette.errorDark : null;
}, function (_ref4) {
  var hidden = _ref4.hidden;
  return hidden ? 0 : 1;
}, function (_ref5) {
  var hidden = _ref5.hidden;
  return hidden ? 0 : undefined;
}, function (_ref6) {
  var hidden = _ref6.hidden;
  return hidden ? 0 : undefined;
}, function (_ref7) {
  var hidden = _ref7.hidden;
  return hidden ? 0 : undefined;
});
var InputMessage = function InputMessage(_ref8) {
  var _ref8$theme = _ref8.theme,
    theme = _ref8$theme === void 0 ? themes["default"] : _ref8$theme,
    error = _ref8.error,
    children = _ref8.children,
    hidden = _ref8.hidden,
    _ref8$showIcon = _ref8.showIcon,
    showIcon = _ref8$showIcon === void 0 ? true : _ref8$showIcon,
    _ref8$invertColors = _ref8.invertColors,
    invertColors = _ref8$invertColors === void 0 ? false : _ref8$invertColors,
    rest = _objectWithoutProperties(_ref8, _excluded);
  return /*#__PURE__*/React.createElement(StyledSub, _extends({
    hidden: hidden,
    theme: theme,
    error: error,
    invertColors: invertColors
  }, rest), error && showIcon ? /*#__PURE__*/React.createElement(React.Fragment, null, ' ', /*#__PURE__*/React.createElement(_Icon, {
    name: 'error',
    color: invertColors ? 'white' : 'errorDark',
    "aria-hidden": true
  }), ' ') : null, /*#__PURE__*/React.createElement("span", null, children));
};
var _InputMessage = withDefaultTheme(/*#__PURE__*/memo(InputMessage));

export default _InputMessage;
